import { useState, useEffect } from 'react';

const useGoogleRecaptcha = (siteKey, disable) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (!disable) {
      const scriptId = 'google-recaptcha';
      if (document.getElementById(scriptId)) {
        // No need to load the script if it's already there
        setLoaded(true);
        return;
      }

      const script = document.createElement('script');
      script.id = scriptId;
      script.src = 'https://www.google.com/recaptcha/api.js' + (siteKey ? `?render=${siteKey}` : '');
      script.async = true;
      script.defer = true;

      script.onload = () => {
        if (window.grecaptcha) {
          window.grecaptcha.ready(() => {
            setLoaded(true);
          });
        }
      };

      document.body.appendChild(script);
    }
  }, [siteKey, disable]);

  return loaded;
};

export default useGoogleRecaptcha;